'use strict';

define('vbsw/private/tokenRelayUtils',[
  'vbc/private/utils',
], (
  Utils,
) => {
  let tokenRelayHandler;

  /**
   *
   */
  class TokenRelayUtils {
    /**
     * Set the tokenRelayHandler property.
     * This is used by SecurityHelpers.getServiceAccessToken() to ensure the same logic is used for requests handled
     * by the TokenRelayHandlerPlugin.
     *
     * @param {Object} handler the TokenRelayHandlerPlugin instance.
     */
    static setTokenRelayHandler(handler) {
      if (!handler.getAuthHeader) {
        throw Error('TokenRelayHandler is not the correct type');
      }

      tokenRelayHandler = handler;
    }

    /**
     * Determine if the getTokenRelayAuthToken() logic (from TokenRelayHandlerPlugin) can be used.
     *
     * @returns {boolean}
     */
    static useTokenRelayHandler() {
      // TokenRelayHandler has not been set
      if (!tokenRelayHandler) {
        return false;
      }

      // Unittests don't necessarily setup fetch plugins, so use simple fetch request on the
      // tokenRelayUrl
      if (Utils.isUnitTestMode()) {
        return false;
      }

      return true;
    }

    /**
     * Use the TokenRelayHandlerPlugin mechanism to retrieve the token relay authentication token.
     *
     * @param {string} tokenRelayUrl
     * @param {Object} tokenRelayAuthentication
     * @param {boolean} tokenRelay2
     * @return {string} token
     */
    static getTokenRelayAuthToken(tokenRelayUrl, tokenRelayAuthentication, tokenRelay2) {
      if (!tokenRelayHandler) {
        throw Error('TokenRelayHandler has not been set');
      }

      // Create Request object to satisfy DT overrides to TokenRelayHandlerPlugin
      // (e.g. getTokenCacheKey() and processTokenRelayAuthentication())
      const request = new Request(tokenRelayUrl);
      return tokenRelayHandler.getAuthHeader(request, tokenRelayUrl, tokenRelayAuthentication, tokenRelay2)
        .then((token) => {
          if (token) {
            // TokenRelayHandlerPlugin.getAuthHeader() always returns a token with the 'Bearer ' prefix.
            // Strip starting 'Bearer' prefix and return pure value.
            return TokenRelayUtils.trimToken(token);
          }
          return null;
        });
    }

    /**
     * Strip starting 'Bearer' prefix and return pure value
     * @param {string} token the bearer token
     * @return {string} token
     */
    static trimToken(token) {
      return token.replace(/^(Bearer)/, '').trim();
    }
  }

  return TokenRelayUtils;
});

